import {FC, useEffect} from 'react'

// demo component with title defined

const title = 'List of Vendors'

const VendorList: FC<{setTitle: (title: string) => void}> = ({setTitle}) => {
  useEffect(() => {
    if (title && setTitle) setTitle(title)
  }, [setTitle])

  return (
    // html starts here
    <div>
      <h3>How to create a new vendor</h3>
      <p>
        To create a new vendor click on the &quot;Add&quot; button located in the top right of the
        vendors list. This will open a form with text fields required for the creation of a vendor.
        Fill the fields with appropriate data and click the create button located at the end of the
        form. Your vendor has been created.
      </p>
    </div>
    // html ends here
  )
}

export default VendorList
